import { getOrgsRequest } from 'api/Orgs/api';
import { Org, OrgsFilterParams } from 'api/Orgs/types';
import getErrorFromPromiseReason from 'app/helpers/getErrorFromPromiseReason';

import { message } from 'antd';
import { useCallback, useState } from 'react';

const useOrgs = () => {
  const [ isLoading, setIsLoading ] = useState<boolean>(false);
  const [ response, setResponse ] = useState<Org[]>([]);

  const fetchOrgs = useCallback((filter: OrgsFilterParams, abortController?: AbortController) => {
    setIsLoading(true);
    getOrgsRequest(filter, abortController)
      .then((response) => {
        setResponse(response.data);
      })
      .catch((reason) => {
        if (!abortController?.signal.aborted) {
          message.error(getErrorFromPromiseReason(reason));
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return { response, isLoading, fetchOrgs, setResponse };
};

export default useOrgs;
